//This is the ADMIN view of all scheduled games and events

import React, { useEffect, useState } from 'react'
import './AdminGameResults.css'
import AdminNavigation from './AdminNavigation'
import { useNavigate, useParams } from 'react-router-dom'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import Modal from '../../shared/components/UIElements/Modal'
import AdminButton from '../../shared/components/UIElements/AdminButton'
import { useHttpClient } from '../../shared/hooks/http-hook'

const AdminGameResultsPlayoff2 = () => {
	const { sendRequest, clearError } = useHttpClient()
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [homeRoster, setHomeRoster] = useState()
	const [homeTeamName, setHomeTeamName] = useState()
	const [homeTeamId, setHomeTeamId] = useState()
	const [visitorRoster, setVisitorRoster] = useState()
	const [visitorTeamName, setVisitorTeamName] = useState()
	const [visitorTeamId, setVisitorTeamId] = useState()
	const [rosterPlayerGameStats, setRosterPlayerGameStats] = useState()
	const [gameStats, setGameStats] = useState([])
	const [dayOfWeek, setDayOfWeek] = useState()
	const [date, setDate] = useState()
	const [time, setTime] = useState()
	const [venue, setVenue] = useState()
	const [leagueName, setLeagueName] = useState()
	const [description, setDescription] = useState()
	const gameId = useParams().gameId
	const [allPenaltiesFromThisGame, setAllPenaltiesFromThisGame] = useState()
	const [allGoalsFromThisGame, setAllGoalsFromThisGame] = useState() //  < - - - - - - - - -
	const [bothRosterDropdown, setBothRosterDropdown] = useState([])
	const [homeRosterDropdown, setHomeRosterDropdown] = useState([])
	const [visitorRosterDropdown, setVisitorRosterDropdown] = useState([])
	const [homeGoalieDropdown, setHomeGoalieDropdown] = useState([])
	const [visitorGoalieDropdown, setVisitorGoalieDropdown] = useState([])
	const [showConfirmModal, setShowConfirmModal] = useState(false)
	//******************************************************** */
	//
	//               Penalty useState's
	//
	//******************************************************* */
	const [showAddHomePenaltyModal, setShowAddHomePenaltyModal] = useState(false)
	const [
		homePenalizedPlayerNumberAndName,
		setHomePenalizedPlayerNumberAndName,
	] = useState()
	const [homePenalizedPlayerId, setHomePenalizedPlayerId] = useState()
	const [homePenaltyType, setHomePenaltyType] = useState()
	const [homePenaltyMinutes, setHomePenaltyMinutes] = useState()
	const [homePenaltyPeriod, setHomePenaltyPeriod] = useState()
	const [homePenaltyTime, setHomePenaltyTime] = useState()
	const [showAddVisitorPenaltyModal, setShowAddVisitorPenaltyModal] =
		useState(false)
	const [
		visitorPenalizedPlayerNumberAndName,
		setVisitorPenalizedPlayerNumberAndName,
	] = useState()
	const [visitorPenalizedPlayerId, setVisitorPenalizedPlayerId] = useState()
	const [visitorPenaltyType, setVisitorPenaltyType] = useState()
	const [visitorPenaltyMinutes, setVisitorPenaltyMinutes] = useState()
	const [visitorPenaltyPeriod, setVisitorPenaltyPeriod] = useState()
	const [visitorPenaltyTime, setVisitorPenaltyTime] = useState()
	const [deletePenaltyTeamName, setDeletePenaltyTeamName] = useState()
	const [deletePenaltyId, setDeletePenaltyId] = useState()
	const [penaltyDeleted, setPenaltyDeleted] = useState()
	const [showPenaltyDeleteModal, setShowPenaltyDeleteModal] = useState()
	const [resetForPenalty, setResetForPenalty] = useState()
	const [penaltyId, setPenaltyId] = useState('')
	const [editPenaltyTeamName, setEditPenaltyTeamName] = useState()
	const [editPenaltyType, setEditPenaltyType] = useState()
	const [editPenaltyId, setEditPenaltyId] = useState()
	const [editPenaltyPeriod, setEditPenaltyPeriod] = useState()
	const [editPenaltyTime, setEditPenaltyTime] = useState()
	const [editPenaltyMinutes, setEditPenaltyMinutes] = useState()
	const [editPenaltyPlayer, setEditPenaltyPlayer] = useState()
	const [editPenaltyDropdown, setEditPenaltyDropdown] = useState([])
	const [showEditPenaltyModal, setShowEditPenaltyModal] = useState()
	const [editPenaltyPlayerNumberAndName, setEditPenaltyPlayerNumberAndName] =
		useState()
	const [newlyEditedPenaltyPlayer, setNewlyEditedPenaltyPlayer] = useState()
	const [newlyEditedPenaltyType, setNewlyEditedPenaltyType] = useState()
	const [newlyEditedPenaltyMinutes, setNewlyEditedPenaltyMinutes] = useState()
	const [newlyEditedPenaltyPeriod, setNewlyEditedPenaltyPeriod] = useState()
	const [newlyEditedPenaltyTime, setNewlyEditedPenaltyTime] = useState()
	//**************************************************************** */
	//
	//     Goal useState's
	//
	//*************************************************************** */
	const [homeGoalies, setHomeGoalies] = useState()
	const [visitorGoalies, setVisitorGoalies] = useState()
	const [homeGoalieRosterPlayerId, setHomeGoalieRosterPlayerId] = useState()
	const [homeGoalieName, setHomeGoalieName] = useState()
	const [visitorGoalieRosterPlayerId, setVisitorGoalieRosterPlayerId] =
		useState()
	const [visitorGoalieName, setVisitorGoalieName] = useState()

	// NEW: goalie scored on states
	const [homeGoalAgainstGoalieId, setHomeGoalAgainstGoalieId] = useState()
	const [homeGoalAgainstGoalieName, setHomeGoalAgainstGoalieName] = useState()
	const [visitorGoalAgainstGoalieId, setVisitorGoalAgainstGoalieId] = useState()
	const [visitorGoalAgainstGoalieName, setVisitorGoalAgainstGoalieName] =
		useState()
	const [editOriginalAgainstGoalieId, setEditOriginalAgainstGoalieId] =
		useState('')
	const [editOriginalAgainstGoalieName, setEditOriginalAgainstGoalieName] =
		useState('')
	const [editGoalAgainstGoalieName, setEditGoalAgainstGoalieName] = useState('')
	const [newlyEditedGoalAgainstGoalieId, setNewlyEditedGoalAgainstGoalieId] =
		useState(null)
	const [
		newlyEditedGoalAgainstGoalieName,
		setNewlyEditedGoalAgainstGoalieName,
	] = useState(null)

	const [showAddHomeGoalModal, setShowAddHomeGoalModal] = useState(false)
	const [showAddVisitorGoalModal, setShowAddVisitorGoalModal] = useState(false)
	const [homeScorer, setHomeScorer] = useState()
	const [homeAssist1, setHomeAssist1] = useState()
	const [homeAssist2, setHomeAssist2] = useState()
	const [homeGoalPeriod, setHomeGoalPeriod] = useState()
	const [homeGoalTime, setHomeGoalTime] = useState()
	const [visitorScorer, setVisitorScorer] = useState()
	const [visitorAssist1, setVisitorAssist1] = useState()
	const [visitorAssist2, setVisitorAssist2] = useState()
	const [visitorGoalPeriod, setVisitorGoalPeriod] = useState()
	const [visitorGoalTime, setVisitorGoalTime] = useState()
	const [resetForGoal, setResetForGoal] = useState()
	const [scorerNumberAndName, setScorerNumberAndName] = useState()
	const [a1NumberAndName, setA1NumberAndName] = useState()
	const [a2NumberAndName, setA2NumberAndName] = useState()
	const [currentHomeScore, setCurrentHomeScore] = useState()
	const [currentVisitorScore, setCurrentVisitorScore] = useState()
	const [showEditGoalModal, setShowEditGoalModal] = useState(false)
	const [editGoalId, setEditGoalId] = useState()
	const [editGoalTeamName, setEditGoalTeamName] = useState()
	const [editGoalDropdown, setEditGoalDropdown] = useState([])
	const [editGoalPeriod, setEditGoalPeriod] = useState()
	const [editGoalTime, setEditGoalTime] = useState()
	const [editOriginalGoalScorer, setEditOriginalGoalScorer] = useState()
	const [editOriginalA1, setEditOriginalA1] = useState()
	const [editOriginalA2, setEditOriginalA2] = useState()
	const [editGoalScorer, setEditGoalScorer] = useState()
	const [editGoalA1, setEditGoalA1] = useState()
	const [editGoalA2, setEditGoalA2] = useState()
	const [editGoalScorerNumberAndName, setEditGoalScorerNumberAndName] =
		useState()
	const [newlyEditedGoalScorer, setNewlyEditedGoalScorer] = useState()
	const [editGoalA1NumberAndName, setEditGoalA1NumberAndName] = useState()
	const [newlyEditedAssist1, setNewlyEditedAssist1] = useState()
	const [editGoalA2NumberAndName, setEditGoalA2NumberAndName] = useState()
	const [newlyEditedAssist2, setNewlyEditedAssist2] = useState()
	const [newlyEditedGoalPeriod, setNewlyEditedGoalPeriod] = useState()
	const [newlyEditedGoalTime, setNewlyEditedGoalTime] = useState()
	const [showGoalDeleteModal, setShowGoalDeleteModal] = useState(false)
	const [goalDeleted, setGoalDeleted] = useState()
	const [deleteGoalTeamName, setDeleteGoalTeamName] = useState()
	const [deleteGoalId, setDeleteGoalId] = useState()
	const [editGoalTeamId, setEditGoalTeamId] = useState()
	const [showSubmitGameModal, setShowSubmitGameModal] = useState()
	const [winningGoalieId, setWinningGoalieId] = useState('')
	const [losingGoalieId, setLosingGoalieId] = useState('')

	//Here, I want to go to the backend, using the gameId, and get the roster lists
	//of both the home team and the visiting team.   getGameRostersAndPointsPerPeriod in admin-controller.js
	//UPDATE 12/22/2024:  I'm also getting all the goals for this game should they exist yet
	//
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/admin/${gameId}/rostersAndPoints`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				console.log(
					'rosterPlayerGameStats: ' +
						JSON.stringify(responseData.rosterPlayerGameStats),
				)

				setHomeRoster(responseData.homeRoster)
				setHomeTeamId(responseData.homeTeamId)
				setHomeTeamName(responseData.homeTeamName)
				setVisitorRoster(responseData.visitorRoster)
				setVisitorTeamId(responseData.visitorTeamId)
				setVisitorTeamName(responseData.visitorTeamName)
				setRosterPlayerGameStats(responseData.rosterPlayerGameStats)
				setGameStats(responseData.gameStats)
				setDayOfWeek(responseData.dayOfWeek)
				setDescription(responseData.description)
				setDate(responseData.date)
				setTime(responseData.time)
				setVenue(responseData.venue)
				setLeagueName(responseData.leagueName)
				setAllPenaltiesFromThisGame(responseData.allPenaltiesFromThisGame)
				setAllGoalsFromThisGame(responseData.allGoalsFromThisGame)
				setHomeGoalies(responseData.homeGoalies)
				setVisitorGoalies(responseData.visitorGoalies)

				//******************************************************************* */
				//
				// At the beginning of the game, then after every goal, let's calculate
				//   how many goals there are for each team, then display the score
				//
				//******************************************************************* */
				/* console.log(
					'allGoalsFromThisGame: ' + JSON.stringify(allGoalsFromThisGame)
				) */
				console.log(
					'allPenaltiesFromThisGame: ' +
						JSON.stringify(allPenaltiesFromThisGame),
				)
				let homeTeamGoals, visitorTeamGoals
				homeTeamGoals = 0
				visitorTeamGoals = 0
				allGoalsFromThisGame &&
					allGoalsFromThisGame.forEach((goal) => {
						if (goal.teamId === homeTeamId) {
							homeTeamGoals = homeTeamGoals + 1
						} else {
							visitorTeamGoals = visitorTeamGoals + 1
						}
					})
				//console.log('homeTeamGoals: ' + homeTeamGoals)
				setCurrentHomeScore(homeTeamGoals)
				//console.log('visitorTeamGoals: ' + visitorTeamGoals)
				setCurrentVisitorScore(visitorTeamGoals)
				//*********************************************************************** */
				//
				//*********************************************************************** */

				let bothRosterDropdownArray,
					homeRosterDropdownArray,
					visitorRosterDropdownArray
				bothRosterDropdownArray = []
				homeRosterDropdownArray = []
				visitorRosterDropdownArray = []
				if (responseData.homeRoster && responseData.visitorRoster) {
					//bothRosterDropdownArray.push(' ')
					responseData.homeRoster.forEach((homePlayer) => {
						bothRosterDropdownArray.push(
							homePlayer.teamName +
								' - ' +
								homePlayer.number +
								' - ' +
								homePlayer.firstName +
								' ' +
								homePlayer.lastName,
						)
						homeRosterDropdownArray.push(
							homePlayer.number +
								' : ' +
								homePlayer.firstName +
								' ' +
								homePlayer.lastName,
						)
					})
					responseData.visitorRoster.forEach((visitorPlayer) => {
						bothRosterDropdownArray.push(
							visitorPlayer.teamName +
								' - ' +
								visitorPlayer.number +
								' - ' +
								visitorPlayer.firstName +
								' ' +
								visitorPlayer.lastName,
						)
						visitorRosterDropdownArray.push(
							visitorPlayer.number +
								' : ' +
								visitorPlayer.firstName +
								' ' +
								visitorPlayer.lastName,
						)
					})
					setBothRosterDropdown(bothRosterDropdownArray)
					setHomeRosterDropdown(homeRosterDropdownArray)
					setVisitorRosterDropdown(visitorRosterDropdownArray)
					//
					/* console.log(
						'homeRosterDropdown: ' + JSON.stringify(homeRosterDropdown)
					) */
					//
					let homeGoalieDropdownArray
					homeGoalieDropdownArray = []
					if (responseData.homeGoalies) {
						responseData.homeGoalies.forEach((goalie) => {
							homeGoalieDropdownArray.push(
								'#' +
									goalie.number +
									' ' +
									goalie.firstName +
									' ' +
									goalie.lastName,
							)
						})
						setHomeGoalieDropdown(homeGoalieDropdownArray)
					}
					//
					//
					let visitorGoalieDropdownArray
					visitorGoalieDropdownArray = []
					if (responseData.visitorGoalies) {
						responseData.visitorGoalies.forEach((goalie) => {
							visitorGoalieDropdownArray.push(
								'#' +
									goalie.number +
									' ' +
									goalie.firstName +
									' ' +
									goalie.lastName,
							)
						})
						setVisitorGoalieDropdown(visitorGoalieDropdownArray)
					}
				}
				setPenaltyDeleted(false)
				setResetForGoal(false)
				setResetForPenalty(false)
				setIsLoading(false)
			} catch (err) {
				//console.log('Error: ' + err)
				setError(err)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [gameId, penaltyDeleted, resetForGoal, resetForPenalty])

	let homePoints1, homePoints2, homePoints3, homePoints4, homePointsTotal
	let visitorPoints1,
		visitorPoints2,
		visitorPoints3,
		visitorPoints4,
		visitorPointsTotal,
		status,
		summary,
		prevHomeGoalieRosterPlayerId,
		prevVisitorGoalieRosterPlayerId
	if (gameStats) {
		if (gameStats.length > 0) {
			console.log('WE HAVE GAME STATS')
			homePoints1 = gameStats[0].homeGoalsPeriod1
			homePoints2 = gameStats[0].homeGoalsPeriod2
			homePoints3 = gameStats[0].homeGoalsPeriod3
			homePoints4 = gameStats[0].homeGoalsPeriod4
			homePointsTotal = gameStats[0].homeGoalsTotal
			visitorPoints1 = gameStats[0].visitorGoalsPeriod1
			visitorPoints2 = gameStats[0].visitorGoalsPeriod2
			visitorPoints3 = gameStats[0].visitorGoalsPeriod3
			visitorPoints4 = gameStats[0].visitorGoalsPeriod4
			visitorPointsTotal = gameStats[0].visitorGoalsTotal
			status = gameStats[0].status
			summary = gameStats[0].summary
			prevHomeGoalieRosterPlayerId = gameStats[0].homeGoalieRosterPlayerId
			prevVisitorGoalieRosterPlayerId = gameStats[0].visitorGoalieRosterPlayerId
		}
	} else {
		console.log('NO GAME STATS YET!!!')
	}
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//

	//
	//
	//
	//
	let listOfPenalties
	listOfPenalties = [
		'Boarding',
		'Body',
		'Butt-Ending',
		'Charging',
		'Checking',
		'Checking from Behind',
		'Contact to the Head',
		'Cross-Check',
		'Delay of Game',
		'Elbowing',
		'Facemask',
		'Fighting',
		'High-Stick',
		'Holding',
		'Hooking',
		'Interference',
		'Kneeing',
		'Misconduct',
		'Obstruction',
		'Roughing',
		'Slashing',
		'Spearing',
		'Too Many Men',
		'Tripping/Slew Foot',
		'Unsportsmanlike Conduct',
		'Other',
	]
	//
	//
	let listOfPeriods
	listOfPeriods = ['1', '2', '3', 'OT', 'SO']
	//
	//
	let listOfMinutes
	listOfMinutes = ['1.5', '3', '4', '5', '10']
	//
	//
	if (prevHomeGoalieRosterPlayerId) {
		console.log('WE HAVE A PREVIOUS GOALIE for the HOME team')
	} else {
		//console.log('no prev goalie')
	}
	//
	//
	if (prevVisitorGoalieRosterPlayerId) {
		console.log('WE HAVE A PREVIOUS GOALIE for the VISITOR team')
	} else {
		//console.log('no prev goalie')
	}
	//
	//
	//
	//
	const returnGoals = (playerId) => {
		let gameGoals
		rosterPlayerGameStats.forEach((rosterPlayer) => {
			if (rosterPlayer.rosterPlayerId === playerId) {
				gameGoals = rosterPlayer.goals
			}
		})
		return gameGoals
	}
	//
	//
	//
	const returnAssists = (playerId) => {
		let gameAssists
		rosterPlayerGameStats.forEach((rosterPlayer) => {
			if (rosterPlayer.rosterPlayerId === playerId) {
				gameAssists = rosterPlayer.assists
			}
		})
		return gameAssists
	}
	//
	//
	//
	//**************************************** */
	//
	//  home team goalie stuff
	//
	//**************************************** */
	//
	//
	let gamehomegoalie
	const handleHomeGoalie = (e) => {
		console.log(e.target.value)
		gamehomegoalie = document.getElementById('homeGoalie').value
		console.log('todays goalie for HOME team: ' + gamehomegoalie)
		const split = gamehomegoalie.split(' ')
		const firstname = split[0]
		const lastname = split[1]
		let homeGoalieRosterPlayerId
		homeGoalies.forEach((goalie) => {
			if (goalie.firstName === firstname && goalie.lastName === lastname) {
				console.log('We have a match: ' + goalie.firstName)
				homeGoalieRosterPlayerId = goalie._id
			}
		})
		console.log('homeGoalieRosterPlayerId: ' + homeGoalieRosterPlayerId)
		setHomeGoalieRosterPlayerId(homeGoalieRosterPlayerId)
		setHomeGoalieName(gamehomegoalie)
	}
	//
	//NOT DOING SHOTS AGAINS FOR COOL HOCKEY EVENTS
	/* let shotsagainst
	const handleShotsAgainst = (e) => {
		shotsagainst = document.getElementById('shotsAgainst').value
		setNewShotsAgainst(shotsagainst)
	} */
	//
	//
	let prevHomeGoalieName
	//
	if (prevHomeGoalieRosterPlayerId && homeGoalies) {
		homeGoalies.forEach((goalie) => {
			if (goalie._id === prevHomeGoalieRosterPlayerId) {
				prevHomeGoalieName = goalie.firstName + ' ' + goalie.lastName
			}
		})
	}
	//
	//
	//
	//**************************************** */
	//
	//  visitor team goalie stuff
	//
	//**************************************** */
	//
	//
	let gamevisitorgoalie
	const handleVisitorGoalie = (e) => {
		console.log(e.target.value)
		gamevisitorgoalie = document.getElementById('visitorGoalie').value
		console.log('todays goalie for VISITOR team: ' + gamevisitorgoalie)
		const split = gamevisitorgoalie.split(' ')
		const firstname = split[0]
		const lastname = split[1]
		let visitorGoalieRosterPlayerId
		visitorGoalies.forEach((goalie) => {
			if (goalie.firstName === firstname && goalie.lastName === lastname) {
				console.log('We have a match: ' + goalie.firstName)
				visitorGoalieRosterPlayerId = goalie._id
			}
		})
		//console.log('visitorGoalieRosterPlayerId: ' + visitorGoalieRosterPlayerId)
		setVisitorGoalieRosterPlayerId(visitorGoalieRosterPlayerId)
		setVisitorGoalieName(gamevisitorgoalie)
	}
	//
	//NOT DOING SHOTS AGAINS FOR COOL HOCKEY EVENTS
	/* let shotsagainst
	const handleShotsAgainst = (e) => {
		shotsagainst = document.getElementById('shotsAgainst').value
		setNewShotsAgainst(shotsagainst)
	} */
	//
	//
	let prevVisitorGoalieName
	//
	if (prevVisitorGoalieRosterPlayerId && visitorGoalies) {
		visitorGoalies.forEach((goalie) => {
			if (goalie._id === prevVisitorGoalieRosterPlayerId) {
				prevVisitorGoalieName = goalie.firstName + ' ' + goalie.lastName
			}
		})
	}
	//
	//
	//
	//
	// NEW: goalie scored on handlers
	const getHomeGoalAgainstGoalie = (event) => {
		const selectedValue = event.target.value

		if (!selectedValue) {
			setHomeGoalAgainstGoalieId('')
			setHomeGoalAgainstGoalieName('')
			return
		}

		const split = selectedValue.split(' ')
		const goalieNumber = split[0].replace('#', '')
		const firstName = split[1]
		const lastName = split[2]
		const cleanGoalieName = `${firstName} ${lastName}`

		let foundGoalieId = ''
		visitorGoalies.forEach((goalie) => {
			if (
				String(goalie.number) === goalieNumber &&
				goalie.firstName === firstName &&
				goalie.lastName === lastName
			) {
				foundGoalieId = goalie._id
			}
		})

		setHomeGoalAgainstGoalieId(foundGoalieId)
		setHomeGoalAgainstGoalieName(cleanGoalieName)
	}

	const getVisitorGoalAgainstGoalie = (event) => {
		const selectedValue = event.target.value

		if (!selectedValue) {
			setVisitorGoalAgainstGoalieId('')
			setVisitorGoalAgainstGoalieName('')
			return
		}

		const split = selectedValue.split(' ')
		const goalieNumber = split[0].replace('#', '')
		const firstName = split[1]
		const lastName = split[2]
		const cleanGoalieName = `${firstName} ${lastName}`

		let foundGoalieId = ''
		homeGoalies.forEach((goalie) => {
			if (
				String(goalie.number) === goalieNumber &&
				goalie.firstName === firstName &&
				goalie.lastName === lastName
			) {
				foundGoalieId = goalie._id
			}
		})

		setVisitorGoalAgainstGoalieId(foundGoalieId)
		setVisitorGoalAgainstGoalieName(cleanGoalieName)
	}
	//
	//
	//
	//
	let navigate = useNavigate()
	//Here, I want to tap into the backend and update stats for the game and rosterPlayers
	// createGameStats
	const logGameStats = async () => {
		//
		alert('Still need to work on what to do when saving a game')
	}
	//
	//*********************************************************** */
	//
	//            Add HOME Goal Modal
	//
	//
	//*********************************************************** */
	const showAddHomeGoalModalHandler = (e) => {
		setHomeGoalAgainstGoalieId('')
		setHomeGoalAgainstGoalieName('')
		setShowAddHomeGoalModal(true)
	}
	//
	const cancelAddHomeGoalHandler = () => {
		setShowAddHomeGoalModal(false)
	}
	//
	const confirmNewHomeGoalHandler = async (event) => {
		event.preventDefault()
		//here, we're adding a new goal.  We should have all the info we need
		//such as the scorer, assist1, assist2, gameId, and teamId
		//
		try {
			setIsLoading(true)

			const response = await fetch(
				process.env.REACT_APP_BACKEND_URL + '/admin/newHomeGoal',
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						homeScorer,
						homeAssist1,
						homeAssist2,
						homeGoalPeriod,
						homeGoalTime,
						homeTeamName,
						homeTeamId,
						gameId,
						scorerNumberAndName,
						a1NumberAndName,
						a2NumberAndName,
						againstGoalieId: homeGoalAgainstGoalieId,
						againstGoalieName: homeGoalAgainstGoalieName,
					}),
				},
			)
			const responseData = await response.json()
			if (!response.ok) {
				throw new Error(
					'ERROR in confirmNewHomeGoalHandler: ' + JSON.stringify(responseData),
				)
			}
			setIsLoading(false)
		} catch (err) {
			setIsLoading(false)
			setError(err.message || 'Something went wrong with creating a new goal')
		}
		setShowAddHomeGoalModal(false)
		setResetForGoal(true)
		window.location.reload()
	}

	//*********************************************************** */
	//
	//            Add VISITOR Goal Modal
	//
	//
	//*********************************************************** */
	const showAddVisitorGoalModalHandler = (e) => {
		setVisitorGoalAgainstGoalieId('')
		setVisitorGoalAgainstGoalieName('')
		setShowAddVisitorGoalModal(true)
	}
	//
	const cancelAddVisitorGoalHandler = () => {
		setShowAddVisitorGoalModal(false)
	}
	//
	const confirmNewVisitorGoalHandler = async (event) => {
		event.preventDefault()
		//here, we're adding a new goal.  We should have all the info we need
		//such as the scorer, assist1, assist2, gameId, and teamId
		//
		try {
			setIsLoading(true)

			const response = await fetch(
				process.env.REACT_APP_BACKEND_URL + '/admin/newVisitorGoal',
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						visitorScorer,
						visitorAssist1,
						visitorAssist2,
						visitorGoalPeriod,
						visitorGoalTime,
						visitorTeamName,
						visitorTeamId,
						gameId,
						scorerNumberAndName,
						a1NumberAndName,
						a2NumberAndName,
						againstGoalieId: visitorGoalAgainstGoalieId,
						againstGoalieName: visitorGoalAgainstGoalieName,
					}),
				},
			)
			const responseData = await response.json()
			if (!response.ok) {
				throw new Error(
					'ERROR in confirmNewVisitorGoalHandler: ' +
						JSON.stringify(responseData),
				)
			}
			setIsLoading(false)
		} catch (err) {
			setIsLoading(false)
			setError(err.message || 'Something went wrong with creating a new goal')
		}
		setShowAddVisitorGoalModal(false)
		setResetForGoal(true)
		window.location.reload()
	}
	//
	//
	//
	//
	//
	const getHomeScorer = (event) => {
		console.log('scorer is ' + event.target.value)
		const scorerNumberAndName = event.target.value
		setScorerNumberAndName(scorerNumberAndName)
		const split = scorerNumberAndName.split(' : ')
		const number = split[0]
		const fullName = split[1]
		const split2 = fullName.split(' ')
		const firstName = split2[0]
		const lastName = split2[1]
		homeRoster.forEach((player) => {
			if (
				player.number === number &&
				player.firstName === firstName &&
				player.lastName === lastName
			) {
				setHomeScorer(player._id)
				console.log('player._id: ' + player._id)
			}
		})
	}
	const getHomeAssist1 = (event) => {
		console.log('assist 1 is ' + event.target.value)
		const a1NumberAndName = event.target.value
		setA1NumberAndName(a1NumberAndName)
		const split = a1NumberAndName.split(' : ')
		const number = split[0]
		const fullName = split[1]
		const split2 = fullName.split(' ')
		const firstName = split2[0]
		const lastName = split2[1]
		homeRoster.forEach((player) => {
			if (
				player.number === number &&
				player.firstName === firstName &&
				player.lastName === lastName
			) {
				setHomeAssist1(player._id)
				console.log('player._id: ' + player._id)
			}
		})
	}
	const getHomeAssist2 = (event) => {
		console.log('assist 2 is ' + event.target.value)
		const a2NumberAndName = event.target.value
		setA2NumberAndName(a2NumberAndName)
		const split = a2NumberAndName.split(' : ')
		const number = split[0]
		const fullName = split[1]
		const split2 = fullName.split(' ')
		const firstName = split2[0]
		const lastName = split2[1]
		homeRoster.forEach((player) => {
			if (
				player.number === number &&
				player.firstName === firstName &&
				player.lastName === lastName
			) {
				setHomeAssist2(player._id)
				console.log('player._id: ' + player._id)
			}
		})
	}

	const getHomeGoalPeriod = (event) => {
		const period = event.target.value
		console.log('period: ' + period)
		setHomeGoalPeriod(period)
	}
	const getHomeGoalTime = (event) => {
		const time = event.target.value
		console.log('time: ' + time)
		setHomeGoalTime(time)
	}
	//
	//
	//
	//
	//
	//
	//
	//
	const getVisitorScorer = (event) => {
		console.log('scorer is ' + event.target.value)
		const scorerNumberAndName = event.target.value
		setScorerNumberAndName(scorerNumberAndName)
		const split = scorerNumberAndName.split(' : ')
		const number = split[0]
		const fullName = split[1]
		const split2 = fullName.split(' ')
		const firstName = split2[0]
		const lastName = split2[1]
		visitorRoster.forEach((player) => {
			if (
				player.number === number &&
				player.firstName === firstName &&
				player.lastName === lastName
			) {
				setVisitorScorer(player._id)
				console.log('player._id: ' + player._id)
			}
		})
	}
	const getVisitorAssist1 = (event) => {
		console.log('assist 1 is ' + event.target.value)
		const a1NumberAndName = event.target.value
		setA1NumberAndName(a1NumberAndName)
		const split = a1NumberAndName.split(' : ')
		const number = split[0]
		const fullName = split[1]
		const split2 = fullName.split(' ')
		const firstName = split2[0]
		const lastName = split2[1]
		visitorRoster.forEach((player) => {
			if (
				player.number === number &&
				player.firstName === firstName &&
				player.lastName === lastName
			) {
				setVisitorAssist1(player._id)
				console.log('player._id: ' + player._id)
			}
		})
	}
	const getVisitorAssist2 = (event) => {
		console.log('assist 2 is ' + event.target.value)
		const a2NumberAndName = event.target.value
		setA2NumberAndName(a2NumberAndName)
		const split = a2NumberAndName.split(' : ')
		const number = split[0]
		const fullName = split[1]
		const split2 = fullName.split(' ')
		const firstName = split2[0]
		const lastName = split2[1]
		visitorRoster.forEach((player) => {
			if (
				player.number === number &&
				player.firstName === firstName &&
				player.lastName === lastName
			) {
				setVisitorAssist2(player._id)
				console.log('player._id: ' + player._id)
			}
		})
	}

	const getVisitorGoalPeriod = (event) => {
		const period = event.target.value
		console.log('period: ' + period)
		setVisitorGoalPeriod(period)
	}
	const getVisitorGoalTime = (event) => {
		const time = event.target.value
		console.log('time: ' + time)
		setVisitorGoalTime(time)
	}
	//
	//
	//
	const getEditHomeGoalAgainstGoalie = (event) => {
		const selectedValue = event.target.value

		if (!selectedValue) {
			setNewlyEditedGoalAgainstGoalieId('')
			setNewlyEditedGoalAgainstGoalieName('')
			setEditGoalAgainstGoalieName('')
			return
		}

		const split = selectedValue.split(' ')
		const goalieNumber = split[0].replace('#', '')
		const firstName = split[1]
		const lastName = split.slice(2).join(' ')
		const cleanGoalieName = `${firstName} ${lastName}`

		let foundGoalieId = ''
		visitorGoalies.forEach((goalie) => {
			if (
				String(goalie.number) === goalieNumber &&
				goalie.firstName === firstName &&
				goalie.lastName === lastName
			) {
				foundGoalieId = goalie._id
			}
		})

		setNewlyEditedGoalAgainstGoalieId(foundGoalieId)
		setNewlyEditedGoalAgainstGoalieName(cleanGoalieName)
		setEditGoalAgainstGoalieName(cleanGoalieName)
	}

	const getEditVisitorGoalAgainstGoalie = (event) => {
		const selectedValue = event.target.value

		if (!selectedValue) {
			setNewlyEditedGoalAgainstGoalieId('')
			setNewlyEditedGoalAgainstGoalieName('')
			setEditGoalAgainstGoalieName('')
			return
		}

		const split = selectedValue.split(' ')
		const goalieNumber = split[0].replace('#', '')
		const firstName = split[1]
		const lastName = split.slice(2).join(' ')
		const cleanGoalieName = `${firstName} ${lastName}`

		let foundGoalieId = ''
		homeGoalies.forEach((goalie) => {
			if (
				String(goalie.number) === goalieNumber &&
				goalie.firstName === firstName &&
				goalie.lastName === lastName
			) {
				foundGoalieId = goalie._id
			}
		})

		setNewlyEditedGoalAgainstGoalieId(foundGoalieId)
		setNewlyEditedGoalAgainstGoalieName(cleanGoalieName)
		setEditGoalAgainstGoalieName(cleanGoalieName)
	}
	//
	//
	//
	//
	//*********************************************************** */
	//
	//            EDIT Goal
	//
	//
	//*********************************************************** */
	//
	//This first function will simply open the 'Edit Goal' modal and
	//   find the goal information so that we pre-populate the edit
	//   form with the correct info.
	//
	const showEditGoalModalHandler = (goal) => {
		setNewlyEditedGoalScorer('')
		setNewlyEditedAssist1('')
		setNewlyEditedAssist2('')
		setNewlyEditedGoalPeriod('')
		setNewlyEditedGoalTime('')
		setEditGoalScorerNumberAndName('')
		setEditGoalA1NumberAndName('')
		setEditGoalA2NumberAndName('')
		setEditOriginalAgainstGoalieId('')
		setEditOriginalAgainstGoalieName('')
		setEditGoalAgainstGoalieName('')
		setNewlyEditedGoalAgainstGoalieId(null)
		setNewlyEditedGoalAgainstGoalieName(null)
		//
		console.log('edit goal: ' + JSON.stringify(goal))
		setEditGoalTeamName(goal.teamName)
		setEditGoalId(goal._id)
		setEditOriginalGoalScorer(goal.scorer)
		setEditOriginalA1(goal.assist1)
		setEditOriginalA2(goal.assist2)
		setEditOriginalAgainstGoalieId(goal.againstGoalieId || '')
		setEditOriginalAgainstGoalieName(goal.againstGoalieName || '')
		setEditGoalAgainstGoalieName(goal.againstGoalieName || '')
		const scorer = goal.scorerNumberAndName
		const a1 = goal.a1NumberAndName
		const a2 = goal.a2NumberAndName
		setEditGoalPeriod(goal.period)
		setEditGoalTime(goal.time)
		if (goal.teamId === homeTeamId) {
			setEditGoalTeamId(homeTeamId)
			homeRosterDropdown.forEach((player) => {
				if (player === scorer) {
					setEditGoalScorer(player)
				}
			})
			homeRosterDropdown.forEach((player) => {
				if (player === a1) {
					setEditGoalA1(player)
				}
			})
			homeRosterDropdown.forEach((player) => {
				if (player === a2) {
					setEditGoalA2(player)
				}
			})
			setEditGoalDropdown(homeRosterDropdown)
		} else {
			setEditGoalTeamId(visitorTeamId)
			visitorRosterDropdown.forEach((player) => {
				if (player === scorer) {
					setEditGoalScorer(player)
				}
			})
			visitorRosterDropdown.forEach((player) => {
				if (player === a1) {
					setEditGoalA1(player)
				}
			})
			visitorRosterDropdown.forEach((player) => {
				if (player === a2) {
					setEditGoalA2(player)
				}
			})
			setEditGoalDropdown(visitorRosterDropdown)
		}
		setShowEditGoalModal(true)
	}
	//
	//
	const getEditGoalScorer = (event) => {
		console.log('EDIT scorer is ' + event.target.value)
		const scorerNumberAndName = event.target.value
		setEditGoalScorerNumberAndName(scorerNumberAndName)
		const split = scorerNumberAndName.split(' : ')
		const number = split[0]
		const fullName = split[1]
		const split2 = fullName.split(' ')
		const firstName = split2[0]
		const lastName = split2[1]
		if (editGoalTeamName === visitorTeamName) {
			visitorRoster.forEach((player) => {
				if (
					player.number === number &&
					player.firstName === firstName &&
					player.lastName === lastName
				) {
					setNewlyEditedGoalScorer(player._id)
					console.log('player._id: ' + player._id)
				}
			})
		} else if (editGoalTeamName === homeTeamName) {
			homeRoster.forEach((player) => {
				if (
					player.number === number &&
					player.firstName === firstName &&
					player.lastName === lastName
				) {
					setNewlyEditedGoalScorer(player._id)
					console.log('player._id: ' + player._id)
				}
			})
		}
	}
	const getEditGoalAssist1 = (event) => {
		console.log('EDIT assist 1 is ' + event.target.value)
		const a1NumberAndName = event.target.value
		setEditGoalA1NumberAndName(a1NumberAndName)
		const split = a1NumberAndName.split(' : ')
		const number = split[0]
		const fullName = split[1]
		const split2 = fullName.split(' ')
		const firstName = split2[0]
		const lastName = split2[1]
		if (editGoalTeamName === visitorTeamName) {
			visitorRoster.forEach((player) => {
				if (
					player.number === number &&
					player.firstName === firstName &&
					player.lastName === lastName
				) {
					setNewlyEditedAssist1(player._id)
					console.log('player._id: ' + player._id)
				}
			})
		} else if (editGoalTeamName === homeTeamName) {
			homeRoster.forEach((player) => {
				if (
					player.number === number &&
					player.firstName === firstName &&
					player.lastName === lastName
				) {
					setNewlyEditedAssist1(player._id)
					console.log('player._id: ' + player._id)
				}
			})
		}
	}
	const getEditGoalAssist2 = (event) => {
		console.log('EDIT assist 2 is ' + event.target.value)
		const a2NumberAndName = event.target.value
		setEditGoalA2NumberAndName(a2NumberAndName)
		const split = a2NumberAndName.split(' : ')
		const number = split[0]
		const fullName = split[1]
		const split2 = fullName.split(' ')
		const firstName = split2[0]
		const lastName = split2[1]
		if (editGoalTeamName === visitorTeamName) {
			visitorRoster.forEach((player) => {
				if (
					player.number === number &&
					player.firstName === firstName &&
					player.lastName === lastName
				) {
					setNewlyEditedAssist2(player._id)
					console.log('player._id: ' + player._id)
				}
			})
		} else if (editGoalTeamName === homeTeamName) {
			homeRoster.forEach((player) => {
				if (
					player.number === number &&
					player.firstName === firstName &&
					player.lastName === lastName
				) {
					setNewlyEditedAssist2(player._id)
					console.log('player._id: ' + player._id)
				}
			})
		}
	}

	const getEditGoalPeriod = (event) => {
		const period = event.target.value
		console.log('EDIT period: ' + period)
		setNewlyEditedGoalPeriod(period)
	}
	const getEditGoalTime = (event) => {
		const time = event.target.value
		console.log('EDIT time: ' + time)
		setNewlyEditedGoalTime(time)
	}
	//
	//
	const cancelEditGoalHandler = () => {
		setNewlyEditedGoalScorer('')
		setNewlyEditedAssist1('')
		setNewlyEditedAssist2('')
		setEditOriginalGoalScorer('')
		setEditOriginalA1('')
		setEditOriginalA2('')
		setEditGoalScorerNumberAndName('')
		setEditGoalA1NumberAndName('')
		setEditGoalA2NumberAndName('')
		setEditGoalScorer('')
		setEditGoalA1('')
		setEditGoalA2('')
		setEditOriginalAgainstGoalieId('')
		setEditOriginalAgainstGoalieName('')
		setEditGoalAgainstGoalieName('')
		setNewlyEditedGoalAgainstGoalieId(null)
		setNewlyEditedGoalAgainstGoalieName(null)
		setShowEditGoalModal(false)
	}
	//
	//
	const confirmEditGoalHandler = async (event) => {
		event.preventDefault()
		//
		const scorer = newlyEditedGoalScorer || editOriginalGoalScorer
		const assist1 = newlyEditedAssist1 || editOriginalA1
		const assist2 = newlyEditedAssist2 || editOriginalA2
		const period = newlyEditedGoalPeriod || editGoalPeriod
		const time = newlyEditedGoalTime || editGoalTime
		const teamName = editGoalTeamName
		const goalId = editGoalId
		const teamId = editGoalTeamId
		//const	gameId,
		const scorerNumberAndName = editGoalScorerNumberAndName || editGoalScorer
		const a1NumberAndName = editGoalA1NumberAndName || editGoalA1
		const a2NumberAndName = editGoalA2NumberAndName || editGoalA2
		//
		const againstGoalieId =
			newlyEditedGoalAgainstGoalieId !== null
				? newlyEditedGoalAgainstGoalieId
				: editOriginalAgainstGoalieId

		const againstGoalieName =
			newlyEditedGoalAgainstGoalieName !== null
				? newlyEditedGoalAgainstGoalieName
				: editOriginalAgainstGoalieName

		console.log('--------- EDITED GOAL INFO: -------------')
		console.log('goalId: ' + goalId)
		console.log('teamId: ' + teamId)
		console.log('scorer: ' + scorer)
		console.log('assist1: ' + assist1)
		console.log('assist2: ' + assist2)
		console.log('period: ' + period)
		console.log('time: ' + time)
		console.log('teamName: ' + teamName)
		console.log('scorerscorerNumberAndName: ' + scorerNumberAndName)
		console.log('a1NumberAndName: ' + a1NumberAndName)
		console.log('a2NumberAndName: ' + a2NumberAndName)
		console.log('againstGoalieId: ' + againstGoalieId)
		console.log('againstGoalieName: ' + againstGoalieName)

		//here, we're editing an existing goal.  We should have all the info we need
		//such as the scorer, assist1, assist2, gameId, and teamId
		//
		try {
			await sendRequest(
				`${process.env.REACT_APP_BACKEND_URL}/admin/editGoal/${goalId}`,
				'PATCH',
				JSON.stringify({
					teamId,
					editOriginalGoalScorer,
					editOriginalA1,
					editOriginalA2,
					scorer,
					assist1,
					assist2,
					period,
					time,
					teamName,
					scorerNumberAndName,
					a1NumberAndName,
					a2NumberAndName,
					againstGoalieId,
					againstGoalieName,
				}),
				{
					'Content-Type': 'application/json',
				},
			)
		} catch (err) {}
		setShowEditGoalModal(false)
		//setResetForGoal(true)
		window.location.reload()
	}
	//
	//
	///*********************************************************** */
	//
	//           DELETE Goal
	//
	//
	//*********************************************************** */
	//
	const showDeleteGoalModalHandler = (goal) => {
		console.log('delete goal: ' + JSON.stringify(goal))
		setDeleteGoalTeamName(goal.teamName)
		setDeleteGoalId(goal._id)
		setShowGoalDeleteModal(true)
	}
	//
	const cancelGoalDeleteHandler = () => {
		setShowGoalDeleteModal(false)
	}
	//
	const confirmGoalDeleteHandler = async () => {
		setShowGoalDeleteModal(false)
		try {
			await sendRequest(
				`${process.env.REACT_APP_BACKEND_URL}/admin/${deleteGoalId}/deleteGoal`,
				'DELETE',
			)
		} catch (err) {
			console.log(err)
		}
		//setGoalDeleted(true)
		window.location.reload()
		console.log('DELETING GOAL...')
	}
	//*********************************************************** */
	//
	//            Add HOME Penalty Modal
	//
	//
	//*********************************************************** */
	const showAddHomePenaltyModalHandler = (e) => {
		setShowAddHomePenaltyModal(true)
	}
	//
	const cancelAddHomePenaltyHandler = () => {
		setShowAddHomePenaltyModal(false)
	}
	//
	//
	const getHomePenaltyPlayer = (event) => {
		console.log('penalized player is ' + event.target.value)
		const penalizedPlayerNumberAndName = event.target.value
		setHomePenalizedPlayerNumberAndName(penalizedPlayerNumberAndName)
		const split = penalizedPlayerNumberAndName.split(' : ')
		const number = split[0]
		const fullName = split[1]
		const split2 = fullName.split(' ')
		const firstName = split2[0]
		const lastName = split2[1]
		homeRoster.forEach((player) => {
			if (
				player.number === number &&
				player.firstName === firstName &&
				player.lastName === lastName
			) {
				setHomePenalizedPlayerId(player._id)
				console.log('player._id: ' + player._id)
			}
		})
	}
	//
	const getHomePenaltyType = (event) => {
		const type = event.target.value
		console.log('type: ' + type)
		setHomePenaltyType(type)
	}
	const getHomePenaltyMinutes = (event) => {
		const min = event.target.value
		console.log('minutes: ' + min)
		setHomePenaltyMinutes(min)
	}
	const getHomePenaltyPeriod = (event) => {
		const period = event.target.value
		console.log('period: ' + period)
		setHomePenaltyPeriod(period)
	}
	const getHomePenaltyTime = (event) => {
		const time = event.target.value
		console.log('time: ' + time)
		setHomePenaltyTime(time)
	}
	//
	//
	const confirmNewHomePenaltyHandler = async () => {
		//event.preventDefault()
		//
		try {
			setIsLoading(true)

			const response = await fetch(
				process.env.REACT_APP_BACKEND_URL + '/admin/newHomePenalty',
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						homePenalizedPlayerId,
						homePenaltyType,
						homePenaltyMinutes,
						homePenaltyPeriod,
						homePenaltyTime,
						homeTeamName,
						homeTeamId,
						gameId,
					}),
				},
			)
			const responseData = await response.json()
			if (!response.ok) {
				throw new Error(
					'ERROR in confirmNewHomePenaltyHandler: ' +
						JSON.stringify(responseData),
				)
			}
			setIsLoading(false)
		} catch (err) {
			setIsLoading(false)
			setError(
				err.message || 'Something went wrong with creating a new home penalty',
			)
		}
		setShowAddHomePenaltyModal(false)
		setResetForPenalty(true)
		window.location.reload()
	}
	//*********************************************************** */
	//
	//            Add VISITOR Penalty Modal
	//
	//
	//*********************************************************** */
	const showAddVisitorPenaltyModalHandler = (e) => {
		setShowAddVisitorPenaltyModal(true)
	}
	//
	//
	const getVisitorPenaltyPlayer = (event) => {
		console.log('penalized player is ' + event.target.value)
		const penalizedPlayerNumberAndName = event.target.value
		setVisitorPenalizedPlayerNumberAndName(penalizedPlayerNumberAndName)
		const split = penalizedPlayerNumberAndName.split(' : ')
		const number = split[0]
		const fullName = split[1]
		const split2 = fullName.split(' ')
		const firstName = split2[0]
		const lastName = split2[1]
		visitorRoster.forEach((player) => {
			if (
				player.number === number &&
				player.firstName === firstName &&
				player.lastName === lastName
			) {
				setVisitorPenalizedPlayerId(player._id)
				console.log('player._id: ' + player._id)
			}
		})
	}
	//
	const getVisitorPenaltyType = (event) => {
		const type = event.target.value
		console.log('type: ' + type)
		setVisitorPenaltyType(type)
	}
	const getVisitorPenaltyMinutes = (event) => {
		const min = event.target.value
		console.log('minutes: ' + min)
		setVisitorPenaltyMinutes(min)
	}
	const getVisitorPenaltyPeriod = (event) => {
		const period = event.target.value
		console.log('period: ' + period)
		setVisitorPenaltyPeriod(period)
	}
	const getVisitorPenaltyTime = (event) => {
		const time = event.target.value
		console.log('time: ' + time)
		setVisitorPenaltyTime(time)
	}
	//
	//
	const cancelAddVisitorPenaltyHandler = () => {
		setShowAddVisitorPenaltyModal(false)
	}
	//
	const confirmNewVisitorPenaltyHandler = async () => {
		//event.preventDefault()
		//
		try {
			setIsLoading(true)

			const response = await fetch(
				process.env.REACT_APP_BACKEND_URL + '/admin/newVisitorPenalty',
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						visitorPenalizedPlayerId,
						visitorPenaltyType,
						visitorPenaltyMinutes,
						visitorPenaltyPeriod,
						visitorPenaltyTime,
						visitorTeamName,
						visitorTeamId,
						gameId,
					}),
				},
			)
			const responseData = await response.json()
			if (!response.ok) {
				throw new Error(
					'ERROR in confirmNewVisitorPenaltyHandler: ' +
						JSON.stringify(responseData),
				)
			}
			setIsLoading(false)
		} catch (err) {
			setIsLoading(false)
			setError(
				err.message ||
					'Something went wrong with creating a new visitor penalty',
			)
		}
		setShowAddVisitorPenaltyModal(false)
		setResetForPenalty(true)
		window.location.reload()
	}
	//
	//
	//
	//*********************************************************** */
	//
	//            EDIT Penalty
	//
	//
	//*********************************************************** */
	//
	//This first function will simply open the 'Edit Penalty' modal and
	//   find the penalty information so that we pre-populate the edit
	//   form with the correct info.
	//
	const showEditPenaltyModalHandler = (penalty) => {
		setNewlyEditedPenaltyPlayer('')
		setNewlyEditedPenaltyType('')
		setNewlyEditedPenaltyMinutes('')
		setNewlyEditedPenaltyPeriod('')
		setNewlyEditedPenaltyTime('')
		setEditPenaltyPlayerNumberAndName('')
		setEditPenaltyPlayer('')
		//
		console.log('edit penalty: ' + JSON.stringify(penalty))
		setEditPenaltyTeamName(penalty.teamName)
		setEditPenaltyType(penalty.penaltyType)
		setEditPenaltyId(penalty._id)
		setEditPenaltyPeriod(penalty.period)
		setEditPenaltyTime(penalty.time)
		setEditPenaltyMinutes(penalty.minutes)
		const perp =
			penalty.jerseyNumber + ' - ' + penalty.firstName + ' ' + penalty.lastName

		console.log('perp: ' + perp)

		if (penalty.teamName === homeTeamName) {
			//setEditPenaltyTeamName(homeTeamName)
			homeRosterDropdown.forEach((hplayer) => {
				if ((hplayer = perp)) {
					setEditPenaltyPlayer(perp)
				}
			})
			setEditPenaltyDropdown(homeRosterDropdown)
		} else {
			setEditPenaltyTeamName(visitorTeamName)
			visitorRosterDropdown.forEach((vplayer) => {
				if ((vplayer = perp)) {
					setEditPenaltyPlayer(perp)
				}
			})
			setEditPenaltyDropdown(visitorRosterDropdown)
		}
		setShowEditPenaltyModal(true)
	}
	//
	//
	const getEditPenaltyPlayer = (event) => {
		console.log('EDIT player is ' + event.target.value)
		const playerNumberAndName = event.target.value
		setEditPenaltyPlayerNumberAndName(playerNumberAndName)
		const split = playerNumberAndName.split(' : ')
		const number = split[0]
		const fullName = split[1]
		const split2 = fullName.split(' ')
		const firstName = split2[0]
		const lastName = split2[1]
		if (editPenaltyTeamName === visitorTeamName) {
			visitorRoster.forEach((player) => {
				if (
					player.number === number &&
					player.firstName === firstName &&
					player.lastName === lastName
				) {
					setNewlyEditedPenaltyPlayer(player._id)
					console.log('player._id: ' + player._id)
				}
			})
		} else if (editPenaltyTeamName === homeTeamName) {
			homeRoster.forEach((player) => {
				if (
					player.number === number &&
					player.firstName === firstName &&
					player.lastName === lastName
				) {
					setNewlyEditedPenaltyPlayer(player._id)
					console.log('player._id: ' + player._id)
				}
			})
		}
	}
	const getEditPenaltyType = (event) => {
		const type = event.target.value
		console.log('EDIT Penalty type: ' + type)
		setNewlyEditedPenaltyType(type)
	}
	const getEditPenaltyMinutes = (event) => {
		const min = event.target.value
		console.log('EDIT Penalty minutes: ' + min)
		setNewlyEditedPenaltyMinutes(min)
	}
	const getEditPenaltyPeriod = (event) => {
		const period = event.target.value
		console.log('EDIT Penalty period: ' + period)
		setNewlyEditedPenaltyPeriod(period)
	}
	const getEditPenaltyTime = (event) => {
		const time = event.target.value
		console.log('EDIT Penalty time: ' + time)
		setNewlyEditedPenaltyTime(time)
	}
	//
	//
	const cancelEditPenaltyHandler = () => {
		setEditPenaltyPlayer('')
		setShowEditPenaltyModal(false)
	}
	//
	//
	const confirmEditPenaltyHandler = async (event) => {
		event.preventDefault()
		//
		const player = newlyEditedPenaltyPlayer || editPenaltyPlayer
		const type = newlyEditedPenaltyType || editPenaltyType
		const period = newlyEditedPenaltyPeriod || editPenaltyPeriod
		const time = newlyEditedPenaltyTime || editPenaltyTime
		const minutes = newlyEditedPenaltyMinutes || editPenaltyMinutes
		const teamName = editPenaltyTeamName
		const penaltyId = editPenaltyId
		//const	gameId,

		console.log('--------- EDITED PENALTY INFO: -------------')
		console.log('newlyEditedPenaltyPlayer: ' + newlyEditedPenaltyPlayer)
		console.log('penaltyId: ' + penaltyId)
		console.log('player: ' + player)
		console.log('teamName: ' + teamName)
		console.log('type: ' + type)
		console.log('period: ' + period)
		console.log('time: ' + time)
		console.log('minutes: ' + minutes)

		//here, we're editing an existing goal.  We should have all the info we need
		//such as the scorer, assist1, assist2, gameId, and teamId
		//
		try {
			await sendRequest(
				`${process.env.REACT_APP_BACKEND_URL}/admin/editPenalty/${penaltyId}`,
				'PATCH',
				JSON.stringify({
					player,
					teamName,
					type,
					period,
					time,
					minutes,
				}),
				{
					'Content-Type': 'application/json',
				},
			)
		} catch (err) {}
		setShowEditGoalModal(false)
		window.location.reload()
	}
	//
	//
	//
	///*********************************************************** */
	//
	//           DELETE Penalty
	//
	//
	//*********************************************************** */
	//
	const showDeletePenaltyModalHandler = (penalty) => {
		console.log('delete Penalty: ' + JSON.stringify(penalty))
		setDeletePenaltyTeamName(penalty.teamName)
		setDeletePenaltyId(penalty._id)
		setShowPenaltyDeleteModal(true)
	}
	//
	const cancelPenaltyDeleteHandler = () => {
		setShowPenaltyDeleteModal(false)
	}
	//
	const confirmPenaltyDeleteHandler = async () => {
		setShowPenaltyDeleteModal(false)
		try {
			await sendRequest(
				`${process.env.REACT_APP_BACKEND_URL}/admin/${deletePenaltyId}/deletePenalty`,
				'DELETE',
			)
		} catch (err) {
			console.log(err)
		}
		//setPenaltyDeleted(true)
		window.location.reload()
		console.log('DELETING PENALTY...')
	}
	//
	//
	//
	//*********************************************************** */
	//
	//            SUBMIT GAME
	//
	//
	//*********************************************************** */
	const winningTeamName =
		Number(currentHomeScore) > Number(currentVisitorScore)
			? homeTeamName
			: visitorTeamName

	const losingTeamName =
		Number(currentHomeScore) > Number(currentVisitorScore)
			? visitorTeamName
			: homeTeamName

	const winningGoalies =
		Number(currentHomeScore) > Number(currentVisitorScore)
			? homeGoalies
			: visitorGoalies

	const losingGoalies =
		Number(currentHomeScore) > Number(currentVisitorScore)
			? visitorGoalies
			: homeGoalies

	const getGoalieLabel = (goalie) => {
		return `#${goalie.number} ${goalie.firstName} ${goalie.lastName}`
	}

	const showSubmitGameHandler = (e) => {
		setShowSubmitGameModal(true)
	}
	//
	const cancelSubmitGameHandler = () => {
		setShowSubmitGameModal(false)
	}
	//
	const confirmSubmitGameHandler = async (event) => {
		event.preventDefault()

		if (Number(currentHomeScore) === Number(currentVisitorScore)) {
			alert(
				'Playoff games cannot end in a tie. Please add the winning goal first.',
			)
			return
		}

		if (!winningGoalieId || !losingGoalieId) {
			alert('Please select both the winning goalie and losing goalie.')
			return
		}

		try {
			setIsLoading(true)

			const response = await fetch(
				process.env.REACT_APP_BACKEND_URL + '/admin/createPlayoffGameStats2',
				{
					method: 'PATCH',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						gameId,
						homeRoster,
						homeTeamId,
						homeTeamName,
						visitorRoster,
						visitorTeamId,
						visitorTeamName,
						dayOfWeek,
						date,
						time,
						venue,
						leagueName,
						allGoalsFromThisGame,
						allPenaltiesFromThisGame,
						winningGoalieId,
						losingGoalieId,
					}),
				},
			)

			const responseData = await response.json()

			if (!response.ok) {
				throw new Error(
					'ERROR in confirmSubmitGameHandler: ' + JSON.stringify(responseData),
				)
			}

			setIsLoading(false)
		} catch (err) {
			setIsLoading(false)
			setError(
				err.message || 'Something went wrong with submitting playoff game',
			)
		}

		setShowSubmitGameModal(false)
		navigate('/admin/masterSchedule')
	}
	//
	//
	//
	//
	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<AdminNavigation />
				<ErrorModal error={error} onClear={errorHandler} />
				{isLoading && (
					<div className='center'>
						<LoadingSpinner />
					</div>
				)}
				{/* //
      //
      //     Add HOME goal MODAL
      //
      // */}
				<Modal
					show={showAddHomeGoalModal}
					onCancel={cancelAddHomeGoalHandler}
					header={homeTeamName}
					footerClass='place-item__modal-actions'
					footer={
						<React.Fragment>
							{/* <p className='modalText' style={{ fontSize: 'xx-large' }}>
								New Goal for {homeTeamName}
							</p> */}
							<br></br>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										SCORER:
									</label>
									<select
										name='ctl00$cphBody$drpMyTeam'
										id='ctl00_cphBody_drpMyTeam'
										onChange={getHomeScorer}
										tabIndex='1'
										className='dropdownElement textbox'
									>
										<option defaultValue></option>
										{homeRosterDropdown.map((player, i) => (
											<option value={player} key={i}>
												{player.toUpperCase()}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										ASSIST:
									</label>
									<select
										name='ctl00$cphBody$drpMyTeam'
										id='ctl00_cphBody_drpMyTeam'
										onChange={getHomeAssist1}
										tabIndex='2'
										className='dropdownElement textbox'
									>
										<option defaultValue></option>
										{homeRosterDropdown.map((player, i) => (
											<option value={player} key={i}>
												{player.toUpperCase()}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										ASSIST:
									</label>
									<select
										name='ctl00$cphBody$drpMyTeam'
										id='ctl00_cphBody_drpMyTeam'
										onChange={getHomeAssist2}
										tabIndex='3'
										className='dropdownElement textbox'
									>
										<option defaultValue></option>
										{homeRosterDropdown.map((player, i) => (
											<option value={player} key={i}>
												{player.toUpperCase()}
											</option>
										))}
									</select>
								</div>
							</div>
							{visitorGoalies && visitorGoalies.length > 1 && (
								<div className='row' style={{ paddingBottom: '2rem' }}>
									<div className='form-group fg-line net goalInputField'>
										<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
											GOALIE SCORED ON:
										</label>
										<select
											onChange={getHomeGoalAgainstGoalie}
											tabIndex='4'
											className='dropdownElement textbox'
											style={{ borderColor: 'red', borderWidth: 'medium' }}
										>
											<option defaultValue></option>
											{visitorGoalieDropdown.map((goalie, i) => (
												<option value={goalie} key={i}>
													{goalie.toUpperCase()}
												</option>
											))}
										</select>
									</div>
								</div>
							)}
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										PERIOD:
									</label>
									<select
										onChange={getHomeGoalPeriod}
										tabIndex='4'
										className='dropdownElement listOfPeriods'
									>
										{/* <option defaultValue>{previousPenaltyOffense2}</option> */}
										<option></option>
										{listOfPeriods.map((period, i) => (
											<option value={period} key={i}>
												{period.toUpperCase()}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										TIME:
									</label>
									<input
										type='text'
										name='description1'
										size='10'
										// defaultValue={description1 && description1}
										placeholder='Ex: 10:55'
										onChange={getHomeGoalTime}
									/>
								</div>
							</div>
							<div
								className='row'
								style={{
									marginTop: '1rem',
									marginLeft: 'auto',
									marginRight: 'auto',
									width: 'auto',
								}}
							>
								<div className='col' style={{ display: 'grid' }}>
									<button
										className='cancelDeleteButtons buttonButton'
										style={{ color: 'red' }}
										danger
										onClick={confirmNewHomeGoalHandler}
									>
										ADD GOAL
									</button>
								</div>
								<div className='col' style={{ display: 'grid' }}>
									<button
										className='cancelDeleteButtons buttonButton'
										inverse
										style={{ float: 'right' }}
										onClick={cancelAddHomeGoalHandler}
									>
										CANCEL
									</button>
								</div>
							</div>
						</React.Fragment>
					}
				></Modal>

				{/* //
      //
      //     Add VISITOR goal MODAL
      //
      // */}
				<Modal
					show={showAddVisitorGoalModal}
					onCancel={cancelAddVisitorGoalHandler}
					header={visitorTeamName}
					footerClass='place-item__modal-actions'
					footer={
						<React.Fragment>
							{/* <p className='modalText' style={{ fontSize: 'xx-large' }}>
								New Goal for {visitorTeamName}
							</p> */}
							<br></br>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										SCORER:
									</label>
									<select
										name='ctl00$cphBody$drpMyTeam'
										id='ctl00_cphBody_drpMyTeam'
										onChange={getVisitorScorer}
										tabIndex='1'
										className='dropdownElement textbox'
									>
										<option defaultValue></option>
										{visitorRosterDropdown.map((player, i) => (
											<option value={player} key={i}>
												{player.toUpperCase()}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										ASSIST:
									</label>
									<select
										name='ctl00$cphBody$drpMyTeam'
										id='ctl00_cphBody_drpMyTeam'
										onChange={getVisitorAssist1}
										tabIndex='2'
										className='dropdownElement textbox'
									>
										<option defaultValue></option>
										{visitorRosterDropdown.map((player, i) => (
											<option value={player} key={i}>
												{player.toUpperCase()}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										ASSIST:
									</label>
									<select
										name='ctl00$cphBody$drpMyTeam'
										id='ctl00_cphBody_drpMyTeam'
										onChange={getVisitorAssist2}
										tabIndex='3'
										className='dropdownElement textbox'
									>
										<option defaultValue></option>
										{visitorRosterDropdown.map((player, i) => (
											<option value={player} key={i}>
												{player.toUpperCase()}
											</option>
										))}
									</select>
								</div>
							</div>
							{homeGoalies && homeGoalies.length > 1 && (
								<div className='row' style={{ paddingBottom: '2rem' }}>
									<div className='form-group fg-line net goalInputField'>
										<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
											GOALIE SCORED ON:
										</label>
										<select
											onChange={getVisitorGoalAgainstGoalie}
											tabIndex='4'
											className='dropdownElement textbox'
											style={{ borderColor: 'red', borderWidth: 'medium' }}
										>
											<option defaultValue></option>
											{homeGoalieDropdown.map((goalie, i) => (
												<option value={goalie} key={i}>
													{goalie.toUpperCase()}
												</option>
											))}
										</select>
									</div>
								</div>
							)}
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										PERIOD:
									</label>
									<select
										onChange={getVisitorGoalPeriod}
										tabIndex='4'
										className='dropdownElement listOfPeriods'
									>
										{/* <option defaultValue>{previousPenaltyOffense2}</option> */}
										<option></option>
										{listOfPeriods.map((period, i) => (
											<option value={period} key={i}>
												{period.toUpperCase()}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										TIME:
									</label>
									<input
										type='text'
										name='description1'
										size='10'
										// defaultValue={description1 && description1}
										placeholder='Ex: 10:55'
										onChange={getVisitorGoalTime}
									/>
								</div>
							</div>
							<div
								className='row'
								style={{
									marginTop: '1rem',
									marginLeft: 'auto',
									marginRight: 'auto',
									width: 'auto',
								}}
							>
								<div className='col' style={{ display: 'grid' }}>
									<button
										className='cancelDeleteButtons buttonButton'
										style={{ color: 'red' }}
										danger
										onClick={confirmNewVisitorGoalHandler}
									>
										ADD GOAL
									</button>
								</div>
								<div className='col' style={{ display: 'grid' }}>
									<button
										className='cancelDeleteButtons buttonButton'
										inverse
										style={{ float: 'right' }}
										onClick={cancelAddVisitorGoalHandler}
									>
										CANCEL
									</button>
								</div>
							</div>
						</React.Fragment>
					}
				></Modal>
				{/* //
      //
      //     EDIT goal MODAL
      //
      // */}
				<Modal
					show={showEditGoalModal}
					onCancel={cancelEditGoalHandler}
					header='EDIT GOAL:'
					footerClass='place-item__modal-actions'
					footer={
						<React.Fragment>
							{/* <p className='modalText' style={{ fontSize: 'xx-large' }}>
								EDIT Goal for {editGoalTeamName}
							</p> */}
							<br></br>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										SCORER:
									</label>
									<select
										name='ctl00$cphBody$drpMyTeam'
										id='ctl00_cphBody_drpMyTeam'
										onChange={getEditGoalScorer}
										tabIndex='1'
										className='dropdownElement textbox'
									>
										<option defaultValue>{editGoalScorer}</option>
										{editGoalDropdown.map((player, i) => (
											<option value={player} key={i}>
												{player.toUpperCase()}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										ASSIST:
									</label>
									<select
										name='ctl00$cphBody$drpMyTeam'
										id='ctl00_cphBody_drpMyTeam'
										onChange={getEditGoalAssist1}
										tabIndex='2'
										className='dropdownElement textbox'
									>
										<option defaultValue>{editGoalA1}</option>
										{editGoalDropdown.map((player, i) => (
											<option value={player} key={i}>
												{player.toUpperCase()}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										ASSIST:
									</label>
									<select
										name='ctl00$cphBody$drpMyTeam'
										id='ctl00_cphBody_drpMyTeam'
										onChange={getEditGoalAssist2}
										tabIndex='3'
										className='dropdownElement textbox'
									>
										<option defaultValue>{editGoalA2}</option>
										{editGoalDropdown.map((player, i) => (
											<option value={player} key={i}>
												{player.toUpperCase()}
											</option>
										))}
									</select>
								</div>
							</div>
							{editGoalTeamId === homeTeamId &&
								visitorGoalies &&
								visitorGoalies.length > 1 && (
									<div className='row' style={{ paddingBottom: '2rem' }}>
										<div className='form-group fg-line net goalInputField'>
											<label
												htmlFor='txtTeamName'
												style={{ fontWeight: 'bold' }}
											>
												GOALIE SCORED ON:
											</label>
											<select
												onChange={getEditHomeGoalAgainstGoalie}
												tabIndex='4'
												className='dropdownElement textbox'
												style={{ borderColor: 'red', borderWidth: 'medium' }}
											>
												<option defaultValue>
													{editGoalAgainstGoalieName}
												</option>
												<option value=''></option>
												{visitorGoalieDropdown.map((goalie, i) => (
													<option value={goalie} key={i}>
														{goalie.toUpperCase()}
													</option>
												))}
											</select>
										</div>
									</div>
								)}

							{editGoalTeamId === visitorTeamId &&
								homeGoalies &&
								homeGoalies.length > 1 && (
									<div className='row' style={{ paddingBottom: '2rem' }}>
										<div className='form-group fg-line net goalInputField'>
											<label
												htmlFor='txtTeamName'
												style={{ fontWeight: 'bold' }}
											>
												GOALIE SCORED ON:
											</label>
											<select
												onChange={getEditVisitorGoalAgainstGoalie}
												tabIndex='4'
												className='dropdownElement textbox'
												style={{ borderColor: 'red', borderWidth: 'medium' }}
											>
												<option defaultValue>
													{editGoalAgainstGoalieName}
												</option>
												<option value=''></option>
												{homeGoalieDropdown.map((goalie, i) => (
													<option value={goalie} key={i}>
														{goalie.toUpperCase()}
													</option>
												))}
											</select>
										</div>
									</div>
								)}
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										PERIOD:
									</label>
									<select
										onChange={getEditGoalPeriod}
										tabIndex='4'
										className='dropdownElement listOfPeriods'
									>
										<option defaultValue>{editGoalPeriod}</option>
										<option></option>
										{listOfPeriods.map((period, i) => (
											<option value={period} key={i}>
												{period.toUpperCase()}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										TIME:
									</label>
									<input
										type='text'
										name='description1'
										size='10'
										defaultValue={editGoalTime}
										placeholder='Ex: 10:55'
										onChange={getEditGoalTime}
									/>
								</div>
							</div>
							<div
								className='row'
								style={{
									marginTop: '4rem',
									marginLeft: 'auto',
									marginRight: 'auto',
									width: 'auto',
								}}
							>
								<div className='col' style={{ display: 'grid' }}>
									<button
										className='cancelDeleteButtons buttonButton'
										style={{ color: 'red' }}
										danger
										onClick={confirmEditGoalHandler}
									>
										SAVE CHANGES
									</button>
								</div>
								<div className='col' style={{ display: 'grid' }}>
									<button
										className='cancelDeleteButtons buttonButton'
										inverse
										style={{ float: 'right' }}
										onClick={cancelEditGoalHandler}
									>
										CANCEL
									</button>
								</div>
							</div>
						</React.Fragment>
					}
				></Modal>
				{/* //
      //
      //     Goal DELETE Modal
      //
      // */}
				<Modal
					show={showGoalDeleteModal}
					onCancel={cancelGoalDeleteHandler}
					header='Are you sure?'
					footerClass='place-item__modal-actions'
					footer={
						<React.Fragment>
							<p className='modalText' style={{ fontSize: 'x-large' }}>
								Delete Goal for {deleteGoalTeamName}?
							</p>
							<br></br>
							<div
								className='row'
								style={{
									marginTop: '4rem',
									marginLeft: 'auto',
									marginRight: 'auto',
									width: 'auto',
								}}
							>
								<div className='col' style={{ display: 'grid' }}>
									<button
										className='cancelDeleteButtons buttonButton'
										style={{ color: 'red' }}
										danger
										onClick={confirmGoalDeleteHandler}
									>
										DELETE GOAL
									</button>
								</div>
								<div className='col' style={{ display: 'grid' }}>
									<button
										className='cancelDeleteButtons buttonButton'
										inverse
										onClick={cancelGoalDeleteHandler}
									>
										CANCEL
									</button>
								</div>
							</div>
						</React.Fragment>
					}
				></Modal>
				{/* //
      //
      //     Add HOME Penalty MODAL
      //
      // */}
				<Modal
					show={showAddHomePenaltyModal}
					onCancel={cancelAddHomePenaltyHandler}
					header='HOME PENALTY:'
					footerClass='place-item__modal-actions'
					footer={
						<React.Fragment>
							{/* <p className='modalText' style={{ fontSize: 'xx-large' }}>
								New Penalty for {homeTeamName}
							</p> */}
							<br></br>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										PLAYER:
									</label>
									<select
										name='ctl00$cphBody$drpMyTeam'
										id='ctl00_cphBody_drpMyTeam'
										onChange={getHomePenaltyPlayer}
										tabIndex='1'
										className='dropdownElement textbox'
									>
										<option defaultValue></option>
										{homeRosterDropdown.map((player, i) => (
											<option value={player} key={i}>
												{player}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										PENALTY TYPE:
									</label>
									<select
										onChange={getHomePenaltyType}
										tabIndex='4'
										className='dropdownElement listOfPeriods'
									>
										{/* <option defaultValue>{previousPenaltyOffense2}</option> */}
										<option></option>
										{listOfPenalties.map((penalty, i) => (
											<option value={penalty} key={i}>
												{penalty}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										MINUTES:
									</label>
									<select
										onChange={getHomePenaltyMinutes}
										tabIndex='4'
										className='dropdownElement listOfPeriods'
									>
										{/* <option defaultValue>{previousPenaltyOffense2}</option> */}
										<option></option>
										{listOfMinutes.map((minute, i) => (
											<option value={minute} key={i}>
												{minute}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										PERIOD:
									</label>
									<select
										onChange={getHomePenaltyPeriod}
										tabIndex='4'
										className='dropdownElement listOfPeriods'
									>
										{/* <option defaultValue>{previousPenaltyOffense2}</option> */}
										<option></option>
										{listOfPeriods.map((period, i) => (
											<option value={period} key={i}>
												{period.toUpperCase()}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										TIME:
									</label>
									<input
										type='text'
										name='description1'
										size='10'
										// defaultValue={description1 && description1}
										placeholder='Ex: 10:55'
										onChange={getHomePenaltyTime}
									/>
								</div>
							</div>
							<div
								className='row'
								style={{
									marginTop: '1rem',
									marginLeft: 'auto',
									marginRight: 'auto',
									width: 'auto',
								}}
							>
								<div className='col' style={{ display: 'grid' }}>
									<button
										className='cancelDeleteButtons buttonButton'
										style={{ color: 'red' }}
										danger
										onClick={confirmNewHomePenaltyHandler}
									>
										ADD PENALTY
									</button>
								</div>
								<div className='col' style={{ display: 'grid' }}>
									<button
										className='cancelDeleteButtons buttonButton'
										inverse
										onClick={cancelAddHomePenaltyHandler}
									>
										CANCEL
									</button>
								</div>
							</div>
						</React.Fragment>
					}
				></Modal>
				{/* //
      //
      //     Add VISITOR Penalty MODAL
      //
      // */}
				<Modal
					show={showAddVisitorPenaltyModal}
					onCancel={cancelAddVisitorPenaltyHandler}
					header='VISITOR PENALTY:'
					footerClass='place-item__modal-actions'
					footer={
						<React.Fragment>
							{/* <p className='modalText' style={{ fontSize: 'xx-large' }}>
								New Penalty for {visitorTeamName}
							</p> */}
							<br></br>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										PLAYER:
									</label>
									<select
										name='ctl00$cphBody$drpMyTeam'
										id='ctl00_cphBody_drpMyTeam'
										onChange={getVisitorPenaltyPlayer}
										tabIndex='1'
										className='dropdownElement textbox'
									>
										<option defaultValue></option>
										{visitorRosterDropdown.map((player, i) => (
											<option value={player} key={i}>
												{player}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										PENALTY TYPE:
									</label>
									<select
										onChange={getVisitorPenaltyType}
										tabIndex='4'
										className='dropdownElement listOfPeriods'
									>
										{/* <option defaultValue>{previousPenaltyOffense2}</option> */}
										<option></option>
										{listOfPenalties.map((penalty, i) => (
											<option value={penalty} key={i}>
												{penalty}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										MINUTES:
									</label>
									<select
										onChange={getVisitorPenaltyMinutes}
										tabIndex='4'
										className='dropdownElement listOfPeriods'
									>
										{/* <option defaultValue>{previousPenaltyOffense2}</option> */}
										<option></option>
										{listOfMinutes.map((minute, i) => (
											<option value={minute} key={i}>
												{minute}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										PERIOD:
									</label>
									<select
										onChange={getVisitorPenaltyPeriod}
										tabIndex='4'
										className='dropdownElement listOfPeriods'
									>
										{/* <option defaultValue>{previousPenaltyOffense2}</option> */}
										<option></option>
										{listOfPeriods.map((period, i) => (
											<option value={period} key={i}>
												{period.toUpperCase()}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										TIME:
									</label>
									<input
										type='text'
										name='description1'
										size='10'
										// defaultValue={description1 && description1}
										placeholder='Ex: 10:55'
										onChange={getVisitorPenaltyTime}
									/>
								</div>
							</div>
							<div
								className='row'
								style={{
									marginTop: '1rem',
									marginLeft: 'auto',
									marginRight: 'auto',
									width: 'auto',
								}}
							>
								<div className='col' style={{ display: 'grid' }}>
									<button
										className='cancelDeleteButtons buttonButton'
										style={{ color: 'red' }}
										danger
										onClick={confirmNewVisitorPenaltyHandler}
									>
										ADD PENALTY
									</button>
								</div>
								<div className='col' style={{ display: 'grid' }}>
									<button
										className='cancelDeleteButtons buttonButton'
										inverse
										onClick={cancelAddVisitorPenaltyHandler}
									>
										CANCEL
									</button>
								</div>
							</div>
						</React.Fragment>
					}
				></Modal>
				{/* //
      //
      //     EDIT Penalty MODAL
      //
      // */}
				<Modal
					show={showEditPenaltyModal}
					onCancel={cancelEditPenaltyHandler}
					header='EDIT PENALTY:'
					footerClass='place-item__modal-actions'
					footer={
						<React.Fragment>
							{/* <p className='modalText' style={{ fontSize: 'xx-large' }}>
								EDIT Penalty for {editPenaltyTeamName}
							</p> */}
							<br></br>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										PLAYER:
									</label>
									<select
										name='ctl00$cphBody$drpMyTeam'
										id='ctl00_cphBody_drpMyTeam'
										onChange={getEditPenaltyPlayer}
										tabIndex='1'
										className='dropdownElement textbox'
									>
										<option defaultValue>{editPenaltyPlayer}</option>
										{editPenaltyDropdown.map((player, i) => (
											<option value={player} key={i}>
												{player}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										PENALTY TYPE:
									</label>
									<select
										name='ctl00$cphBody$drpMyTeam'
										id='ctl00_cphBody_drpMyTeam'
										onChange={getEditPenaltyType}
										tabIndex='2'
										className='dropdownElement textbox'
									>
										<option defaultValue>{editPenaltyType}</option>
										{listOfPenalties.map((penalty, i) => (
											<option value={penalty} key={i}>
												{penalty}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										MINUTES:
									</label>
									<select
										onChange={getEditPenaltyMinutes}
										tabIndex='4'
										className='dropdownElement listOfPeriods'
									>
										<option defaultValue>{editPenaltyMinutes}</option>
										<option></option>
										{listOfMinutes.map((minute, i) => (
											<option value={minute} key={i}>
												{minute}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										PERIOD:
									</label>
									<select
										onChange={getEditPenaltyPeriod}
										tabIndex='4'
										className='dropdownElement listOfPeriods'
									>
										<option defaultValue>{editPenaltyPeriod}</option>
										<option></option>
										{listOfPeriods.map((period, i) => (
											<option value={period} key={i}>
												{period.toUpperCase()}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className='row' style={{ paddingBottom: '2rem' }}>
								<div className='form-group fg-line net goalInputField'>
									<label htmlFor='txtTeamName' style={{ fontWeight: 'bold' }}>
										TIME:
									</label>
									<input
										type='text'
										name='description1'
										size='10'
										defaultValue={editPenaltyTime}
										placeholder='Ex: 10:55'
										onChange={getEditPenaltyTime}
									/>
								</div>
							</div>
							<div
								className='row'
								style={{
									marginTop: '4rem',
									marginLeft: 'auto',
									marginRight: 'auto',
									width: 'auto',
								}}
							>
								<div className='col' style={{ display: 'grid' }}>
									<button
										className='cancelDeleteButtons buttonButton'
										style={{ color: 'red' }}
										danger
										onClick={confirmEditPenaltyHandler}
									>
										SAVE CHANGES
									</button>
								</div>
								<div className='col' style={{ display: 'grid' }}>
									<button
										className='cancelDeleteButtons buttonButton'
										inverse
										style={{ float: 'right' }}
										onClick={cancelEditPenaltyHandler}
									>
										CANCEL
									</button>
								</div>
							</div>
						</React.Fragment>
					}
				></Modal>
				{/* //
      //
      //     Penalty DELETE Modal
      //
      // */}
				<Modal
					show={showPenaltyDeleteModal}
					onCancel={cancelPenaltyDeleteHandler}
					header='Are you sure?'
					footerClass='place-item__modal-actions'
					footer={
						<React.Fragment>
							<p className='modalText' style={{ fontSize: 'x-large' }}>
								Delete Penalty for {deletePenaltyTeamName}?
							</p>
							<br></br>
							<div
								className='row'
								style={{
									marginTop: '4rem',
									marginLeft: 'auto',
									marginRight: 'auto',
									width: 'auto',
								}}
							>
								<div className='col' style={{ display: 'grid' }}>
									<button
										className='cancelDeleteButtons buttonButton'
										style={{ color: 'red' }}
										danger
										onClick={confirmPenaltyDeleteHandler}
									>
										DELETE PENALTY
									</button>
								</div>
								<div className='col' style={{ display: 'grid' }}>
									<button
										className='cancelDeleteButtons buttonButton'
										inverse
										onClick={cancelPenaltyDeleteHandler}
									>
										CANCEL
									</button>
								</div>
							</div>
						</React.Fragment>
					}
				></Modal>
				{/* //
      //
      //     Submit Game Modal
      //
      // */}
				<Modal
					show={showSubmitGameModal}
					onCancel={cancelSubmitGameHandler}
					header='SUBMIT PLAYOFF GAME'
					footerClass='place-item__modal-actions'
					footer={
						<React.Fragment>
							<p className='modalText' style={{ fontSize: 'x-large' }}>
								Pick the winning goalie and losing goalie, then click SUBMIT
							</p>

							<div className='submitGoalieCard'>
								<div className='submitGoaliePicker'>
									<label className='submitGoalieLabel'>
										WINNING GOALIE
										<span>{winningTeamName}</span>
									</label>

									<select
										className='dropdownElement textbox submitGoalieSelect'
										value={winningGoalieId}
										onChange={(e) => setWinningGoalieId(e.target.value)}
									>
										<option value=''>Pick winning goalie</option>

										{winningGoalies &&
											winningGoalies.map((goalie) => (
												<option value={goalie._id} key={goalie._id}>
													{getGoalieLabel(goalie).toUpperCase()}
												</option>
											))}
									</select>
								</div>

								<div className='submitGoaliePicker'>
									<label className='submitGoalieLabel'>
										LOSING GOALIE
										<span>{losingTeamName}</span>
									</label>

									<select
										className='dropdownElement textbox submitGoalieSelect'
										value={losingGoalieId}
										onChange={(e) => setLosingGoalieId(e.target.value)}
									>
										<option value=''>Pick losing goalie</option>

										{losingGoalies &&
											losingGoalies.map((goalie) => (
												<option value={goalie._id} key={goalie._id}>
													{getGoalieLabel(goalie).toUpperCase()}
												</option>
											))}
									</select>
								</div>
							</div>

							<div
								className='row'
								style={{
									marginTop: '2rem',
									marginLeft: 'auto',
									marginRight: 'auto',
									width: 'auto',
								}}
							>
								<div className='col' style={{ display: 'grid' }}>
									<button
										className='cancelDeleteButtons yesNoButton'
										style={{ color: 'red', background: '#e0e0e0' }}
										onClick={confirmSubmitGameHandler}
									>
										SUBMIT
									</button>
								</div>

								<div className='col' style={{ display: 'grid' }}>
									<button
										style={{ background: '#e0e0e0' }}
										className='cancelDeleteButtons yesNoButton'
										onClick={cancelSubmitGameHandler}
									>
										No, not yet
									</button>
								</div>
							</div>
						</React.Fragment>
					}
				/>
				<span>
					{/* <h3 style={{ marginTop: '5rem', textAlign: 'center' }}>
						{leagueName && leagueName}
					</h3> */}
					<h1 style={{ marginTop: '5rem' }}>
						<h1 style={{ color: 'red', fontWeight: 'bold' }}>{description}</h1>{' '}
						{homeTeamName} vs. {visitorTeamName}
					</h1>
					<p style={{ textAlign: 'center' }}>
						{dayOfWeek},{' '}
						{date && date.substr(0, 2) === '01' && 'Jan. ' + date.substr(3, 2)}
						{date && date.substr(0, 2) === '02' && 'Feb. ' + date.substr(3, 2)}
						{date && date.substr(0, 2) === '03' && 'Mar. ' + date.substr(3, 2)}
						{date && date.substr(0, 2) === '04' && 'Apr. ' + date.substr(3, 2)}
						{date && date.substr(0, 2) === '05' && 'May ' + date.substr(3, 2)}
						{date && date.substr(0, 2) === '06' && 'June ' + date.substr(3, 2)}
						{date && date.substr(0, 2) === '07' && 'July ' + date.substr(3, 2)}
						{date && date.substr(0, 2) === '08' && 'Aug. ' + date.substr(3, 2)}
						{date && date.substr(0, 2) === '09' && 'Sept. ' + date.substr(3, 2)}
						{date && date.substr(0, 2) === '10' && 'Oct. ' + date.substr(3, 2)}
						{date && date.substr(0, 2) === '11' && 'Nov. ' + date.substr(3, 2)}
						{date &&
							date.substr(0, 2) === '12' &&
							'Dec. ' + date.substr(3, 2)},{' '}
						{time &&
							time.substr(0, 2) === '01' &&
							'1:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '02' &&
							'2:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '03' &&
							'3:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '04' &&
							'4:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '05' &&
							'5:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '06' &&
							'6:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '07' &&
							'7:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '08' &&
							'8:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '09' &&
							'9:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '10' &&
							'10:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '11' &&
							'11:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '12' &&
							'12:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '13' &&
							'1:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '14' &&
							'2:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '15' &&
							'3:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '16' &&
							'4:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '17' &&
							'5:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '18' &&
							'6:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '19' &&
							'7:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '20' &&
							'8:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '21' &&
							'9:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '22' &&
							'10:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '23' &&
							'11:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '24' &&
							'12:' + time.substr(3, 2) + ' am'}
						, {venue}
					</p>

					{/* //
          //
          //
          // */}
					<div className='row'>
						<div
							className='col'
							style={{
								alignContent: 'center',
							}}
						>
							<h3
								className='iphoneTeamName'
								style={{
									marginTop: '1rem',
									textAlign: 'right',
								}}
							>
								{homeTeamName}
							</h3>
						</div>
						<div className='col'>
							<h3
								style={{
									marginTop: '1rem',
									textAlign: 'center',
									fontSize: 'xxx-large',
								}}
							>
								{currentHomeScore} - {currentVisitorScore}
							</h3>
						</div>

						<div
							className='col'
							style={{
								alignContent: 'center',
							}}
						>
							<h3
								className='iphoneTeamName'
								style={{
									marginTop: '1rem',
									textAlign: 'left',
								}}
							>
								{visitorTeamName}
							</h3>
						</div>
					</div>
				</span>
				{/* //
        //
        //
        // */}
				<div className='row'>
					<div className='col'>
						<button
							className='addButton'
							onClick={(e) => showAddHomeGoalModalHandler()}
						>
							+ GOAL
						</button>
					</div>
					<div className='col'>
						<button
							className='addButton'
							onClick={(e) => showAddHomePenaltyModalHandler()}
						>
							+ PENALTY
						</button>
					</div>
					<div className='col'></div>
					<div className='col'>
						<button
							className='addButton'
							onClick={(e) => showAddVisitorGoalModalHandler()}
						>
							+ GOAL
						</button>
					</div>
					<div className='col'>
						<button
							className='addButton'
							onClick={(e) => showAddVisitorPenaltyModalHandler()}
						>
							+ PENALTY
						</button>
					</div>
				</div>

				{/* //
        //
        //
        // */}
				<div className='heading' style={{ marginTop: '4rem' }}>
					<h1>Scoring:</h1>
				</div>
				<table
					className='AdminRosterSmall resultsTable'
					id='adminRoster'
					style={{
						marginLeft: 'auto',
						marginRight: 'auto',
						marginBottom: '0rem',
						height: 'auto',
						marginTop: '0rem',
						marginBottom: '1rem',
					}}
				>
					<thead>
						<tr className='iphoneTableHeader'>
							<th>Team</th>
							<th>Pd</th>
							<th>Time</th>
							<th>Goal</th>
							<th>Assists</th>
							<th>Goalie</th>
							<th></th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{allGoalsFromThisGame &&
							allGoalsFromThisGame.map((goal, key) => {
								return (
									<tr key={key}>
										<td>{goal.teamName}</td>
										<td>{goal.period}</td>
										<td>{goal.time}</td>
										<td>{goal.scorerNumberAndName}</td>
										<td>
											{goal.a1NumberAndName}
											<br></br>
											{goal.a2NumberAndName}
										</td>
										<td>
											{goal.againstGoalieName ||
												(goal.teamId === homeTeamId &&
												visitorGoalies &&
												visitorGoalies.length === 1
													? `${visitorGoalies[0].firstName} ${visitorGoalies[0].lastName}`
													: goal.teamId === visitorTeamId &&
														  homeGoalies &&
														  homeGoalies.length === 1
														? `${homeGoalies[0].firstName} ${homeGoalies[0].lastName}`
														: '')}
										</td>
										<td style={{ paddingTop: '5px', paddingBottom: '5px' }}>
											<button
												style={{ color: 'black', borderColor: 'black' }}
												className=''
												onClick={(e) => showEditGoalModalHandler(goal)}
											>
												EDIT
											</button>
										</td>
										<td>
											<button
												style={{ color: 'red', borderColor: 'black' }}
												className=''
												onClick={(e) => showDeleteGoalModalHandler(goal)}
											>
												DELETE
											</button>
										</td>
										<td></td>
									</tr>
								)
							})}
					</tbody>
				</table>
				{/* //
        //
        //
        // */}
				<div className='heading' style={{ marginTop: '4rem' }}>
					<h1>Penalties:</h1>
				</div>
				<table
					className='AdminRosterSmall resultsTable'
					id='adminRoster'
					style={{
						marginLeft: 'auto',
						marginRight: 'auto',
						marginBottom: '0rem',
						height: 'auto',
						marginTop: '0rem',
						marginBottom: '1rem',
					}}
				>
					<thead>
						<tr className='iphoneTableHeader'>
							<th>Team</th>
							<th>Pd</th>
							<th>Player</th>
							<th>Type</th>
							<th>Min</th>
							<th>Time</th>
							<th></th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{allPenaltiesFromThisGame &&
							allPenaltiesFromThisGame.map((penalty, key) => {
								return (
									<tr key={key}>
										<td>{penalty.teamName}</td>
										<td>{penalty.period}</td>
										<td>
											{penalty.jerseyNumber} : {penalty.firstName}{' '}
											{penalty.lastName}
										</td>
										<td>{penalty.penaltyType}</td>
										<td>{penalty.minutes}</td>
										<td>{penalty.time}</td>
										<td style={{ paddingTop: '5px', paddingBottom: '5px' }}>
											<button
												style={{ color: 'black', borderColor: 'black' }}
												className=''
												onClick={(e) => showEditPenaltyModalHandler(penalty)}
											>
												EDIT
											</button>
										</td>
										<td>
											<button
												style={{ color: 'red', borderColor: 'black' }}
												className=''
												onClick={(e) => showDeletePenaltyModalHandler(penalty)}
											>
												DELETE
											</button>
										</td>
										<td></td>
									</tr>
								)
							})}
					</tbody>
				</table>

				{/* <div
					className='col-sm'
					style={{
						marginLeft: 'auto',
						marginRight: 'auto',
						display: 'block',
						paddingTop: '3%',
						marginBottom: '10rem',
						textAlign: 'center',
					}}
				>
					<AdminButton onClick={logGameStats}>SAVE</AdminButton>
				</div> */}
				<div
					className='row'
					style={{ marginTop: '5rem', marginBottom: '4rem' }}
				>
					<div className='col'>
						<button
							className='addButton'
							onClick={(e) => showSubmitGameHandler()}
						>
							END OF PLAYOFF GAME. SUBMIT RESULTS
						</button>
					</div>
				</div>
			</React.Fragment>
		</div>
	)
}

export default AdminGameResultsPlayoff2
